import { render, staticRenderFns } from "./DeliveryOrderItem.vue?vue&type=template&id=138fd4ec&scoped=true&"
import script from "./DeliveryOrderItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderItem.vue?vue&type=style&index=0&id=138fd4ec&prod&lang=scss&scoped=true&"
import style1 from "./DeliveryOrderItem.vue?vue&type=style&index=1&id=138fd4ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138fd4ec",
  null
  
)

export default component.exports